// extracted by css-extract-rspack-plugin
export default {"label":"label-uHeUe0 text-sm-medium"};